import { render } from "./LoadingSpiner.vue?vue&type=template&id=7e278457&scoped=true"
const script = {}

import "./LoadingSpiner.vue?vue&type=style&index=0&id=7e278457&scoped=true&lang=css"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e278457"]])

export default __exports__